export default __webpack_public_path__ + "static/media/224.3a084ce7.png";